import { pluralNumber } from "src/util/pluralNumber";

import { PluralForms } from "./formatDeliveryRange";

export type PriceAgeLabels = {
  justNow: string;
  ago: string;
  minutes: PluralForms;
  hours: PluralForms;
  days: PluralForms;
};

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export const formatPriceAge = (
  loadedAt: number | null,
  now: number,
  labels: PriceAgeLabels,
): string | null => {
  if (!loadedAt) return null;

  const elapsed = Math.max(0, now - loadedAt);

  if (elapsed < MINUTE) return labels.justNow;

  const ago = (value: number, forms: PluralForms) =>
    `${value} ${pluralNumber(value, forms)} ${labels.ago}`;

  if (elapsed < HOUR) {
    return ago(Math.floor(elapsed / MINUTE), labels.minutes);
  }

  if (elapsed < DAY) {
    return ago(Math.floor(elapsed / HOUR), labels.hours);
  }

  return ago(Math.floor(elapsed / DAY), labels.days);
};
